import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import Icon from 'components/Icon';

const ActionButtons = ({ theme, ctaData }) => {
  if (!ctaData || !ctaData.length) return null;
  return (
    <div className={theme.actionButtons}>
      {_.map(ctaData, ({ icon, viewBox, text, url, onClick, externalLink }) => {
        if (!text) return null;
        const iconElement = icon && (
          <Icon className={theme.actionButtonIcon} icon={icon} viewBox={viewBox} color="white" />
        );
        const redirect = externalLink ? { href: url } : { to: url };
        return (
          <Link
            key={text}
            data-test="shared-tile-action-button"
            className={theme.actionButton}
            {...redirect}
            onClick={onClick}
          >
            {iconElement}
            {text}
          </Link>
        );
      })}
    </div>
  );
};

ActionButtons.defaultProps = {
  ctaData: [],
  theme: {},
};

ActionButtons.propTypes = {
  ctaData: PropTypes.arrayOf(PropTypes.shape({})),
  theme: PropTypes.shape({}),
};

export default ActionButtons;
